import React, { useEffect, useRef, useState } from 'react';
//import { Carousel } from 'react-bootstrap';
//import Carousel from "react-multi-carousel";
import { isEmpty, size } from 'lodash';
import defaultValues from '../../constant/defaultValues';

import MediumPopup from '../MediumPopup';

import defaultVideo from '../../images/default_video_images (2).jpg';
import ImageCarousel from '../common/ImageCarousel';
import ImageVideoCarosel from '../common/ImageVideoCarosel';
import orexTradeLogo from "../../images/orexTradeLogo.jpg";

function CompanyImageVideo(props) {

  const { IMAGE_PATH } = defaultValues;
  // const VideosLink = props.data
  const [mediaItems, setMediaItems] = useState([]);
  const [carslItems, setCarslItems] = useState([]);

  const data = props.data;
  const [showNoData, setShowNoData] = useState(true);
  const [open, setOpen] = useState(false);

  const viewPageRef = useRef("viewPage");

  function extractYouTubeID(url) {
    // const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(youtubeRegex);
    return match ? match[1] : null;
  }

  function extractYouTubeIdByGoogle(url) {
    const googleSearchRegex = /vid:([a-zA-Z0-9_-]{11})/;

    let match = url.match(googleSearchRegex);
    if (match) {
      return match[1];
    }
    return null;
  }


  function extractVimeoID(url) {
    const vimeoRegex = /(?:vimeo\.com\/)([0-9]{6,11})/;
    const match = url.match(vimeoRegex);
    return match ? match[1] : null;
  }

  useEffect(() => {
    if (size(data) > 0) {
      if (size(data.images) > 0 || size(data.video) > 0) {
        setShowNoData(false);
      } else {
        setShowNoData(true);
      }

    } else {
      setShowNoData(true);
    }
  }, [props.data]);

  useEffect(() => {
    if (!isEmpty(data)) {

      let videoRes = data.videos.map((val, idx) => {
        let embedURL = '';

        if (val.detail.includes('youtube.com') || val.detail.includes('youtu.be')) {
          const youtubeID = extractYouTubeID(val.detail);
          if (youtubeID) {
            embedURL = `https://www.youtube.com/embed/${youtubeID}`;
          } else {
            console.error('Invalid YouTube URL');
          }
        }
        // Check if the URL is from Vimeo
        else if (val.detail.includes('vimeo.com')) {
          const vimeoID = extractVimeoID(val.detail);
          if (vimeoID) {
            embedURL = `https://player.vimeo.com/video/${vimeoID}`;
          } else {
            console.error('Invalid Vimeo URL');
          }
        } else if (val.detail.includes('google.com')) {
          const youtubeID = extractYouTubeIdByGoogle(val.detail);
          if (youtubeID) {
            embedURL = `https://www.youtube.com/embed/${youtubeID}`;
          } else {
            console.error('Invalid YouTube URL');
          }
        } else {
          console.error('Unsupported video platform');
        }
        const VideoDetails = {
          id: val.id,
          src: !isEmpty(embedURL) ? embedURL : val.detail,
          //src: val.detail,
          // thumb: defaultVideo,
          thumb: !isEmpty(data.company_logo) ? IMAGE_PATH.BASE_URL + '/company_logo/' + data.company_logo : orexTradeLogo ,
          subHtml: `<div className="lightGallery-captions">
                      <h4>Photo by <a href="https://unsplash.com/@dann">Dan</a></h4>
                      <p>Published on November 13, 2018</p>
                  </div>`,
          type: 'Video'
        };

        return VideoDetails;
      });

      let imgRes = data.images.map((val, idx) => {

        const ImagesDetails = {
          id: val.id,
          src: (val.detail) ? IMAGE_PATH.BASE_URL + '/company_images/' + val.detail : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTw_HeSzHfBorKS4muw4IIeVvvRgnhyO8Gn8w&s",
          thumb: (val.detail) ? IMAGE_PATH.BASE_URL + '/company_images/' + val.detail : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTw_HeSzHfBorKS4muw4IIeVvvRgnhyO8Gn8w&s",
          subHtml: `<div className="lightGallery-captions">
                    <h4>Photo by <a href="https://unsplash.com/@dann">Dan</a></h4>
                    <p>Published on November 13, 2018</p>
                </div>`,
          type: 'Images'
        };

        return ImagesDetails;

      });

      if (!isEmpty(videoRes) || !isEmpty(imgRes)) {
        setShowNoData(false);
      }
      let mediaDetails = videoRes.concat(imgRes);
      setMediaItems(mediaDetails);
      if (!isEmpty(carslItems)) {
        setCarslItems(mediaDetails);
      }
      setCarslItems(mediaDetails);
    }

  }, [props.data, data])

  const handleClick = (e, indx) => {
    console.log("handleClick ========= ", indx);

    let x = RotateMediaItems(indx);
    console.log("afterRotate ================== ", x);
    setCarslItems(x);
    setTimeout(() => {
      setOpen(true);
    }, 1500);
  }

  const RotateMediaItems = (idx) => {
    // console.log("idx ============= ", idx);
    return [...mediaItems.slice(idx, mediaItems.length), ...mediaItems.slice(0, idx)];
  }

  console.log("",carslItems)

  return (
    <>
      {
        mediaItems && !isEmpty(mediaItems) && <div className='bg-white company-video'>  <ImageCarousel mediaItems={mediaItems} handleClick={handleClick} containerClass="agrofood-banner" ref={viewPageRef}></ImageCarousel>
        

          <MediumPopup
            title="Videos/Images"
            mediummodalShow={open}
            setMediumModalShow={setOpen}
            closeButtonLabel="Cancel"
          >
            <ImageVideoCarosel mediaItems={carslItems} ></ImageVideoCarosel>

          </MediumPopup >

        </div >
      }
    </>
  )
}

export default CompanyImageVideo





